import {
  ACTIVE_STATUS,
  CANCELED_TRANSACTION,
  CLOSED_STATUS,
  COMPLETED_STATUS,
  CONTRACT_REJECTED,
  ESCALATION_STATUS,
  ITEM_ACCEPTED_STATUS,
  OUT_OF_STOCK_STATUS,
  PENDING_APPROVAL,
  PENDING_PAYMENT_VERIFICATION,
  RESOLVED_STATUS,
  WAITING_FOR_INSPECTION,
  WAITING_FOR_SETTLEMENT_CLOSE_STATUS,
  WAITING_FOR_SETTLEMENT_RESOLVE_STATUS,
  WAITING_FOR_SHIPPING,
} from "../../../components/contractListItem/constants";

export const HEADER = "المعاملات الخاصة بك";
export const BRIEF = "يمكنك الإطلاع على كل معاملاتك وتتبع حالتها أولا بأول.";
export const ACTIVE_CONTRACTS_TAB = "المعاملات النشطة";
export const PREVIOUS_CONTRACTS_TAB = "المعاملات السابقة";
export const TRANSFER_REQUESTS_TAB = "طلبات التحويل";
export const BUTTON = {
  SEARCH: "البحث عن طريق رمز المعاملة",
  SEARCH_TRANS: "البحث عن طريق رمز الدفع",
  ALL_CASES: "جميع الحالات",
  START_DATE: "تاريخ البدء",
  END_DATE: "تاريخ الانتهاء",
};

export const cashInOptions = [
  { id: "", label: "الكل" },
  { id: "Inma", label: "Inma" },
  { id: "Rajhi", label: "Rajhi" },
  { id: "Moyaser", label: "Moyaser" },
  { id: "Heperpay", label: "Heperpay" },
  { id: "Tabby unsettled", label: "Tabby unsettled" },
  { id: "Inma & Moyaser", label: "Inma & Moyaser" },
  { id: "Rajhi & Moyaser", label: "Rajhi & Moyaser" },
];

export const active_status = [
  { id: "ALL_CASES", label: "الكل" },
  { id: "CREATED", label: ACTIVE_STATUS },
  { id: "WAITING_FOR_DELIVERY", label: WAITING_FOR_SHIPPING },
  { id: "ITEM_INSPECTION", label: WAITING_FOR_INSPECTION },
  { id: "ITEM_ACCEPTED", label: ITEM_ACCEPTED_STATUS },
  {
    id: "WAITING_FOR_SETTLEMENT_CLOSE",
    label: WAITING_FOR_SETTLEMENT_CLOSE_STATUS,
  },
  {
    id: "WAITING_FOR_SETTLEMENT_RESOLVE",
    label: WAITING_FOR_SETTLEMENT_RESOLVE_STATUS,
  },
  { id: "CANCELED", label: CANCELED_TRANSACTION },
  { id: "DELIVERY_ESCALATION,INSPECTION_ESCALATION", label: ESCALATION_STATUS },
  { id: "OUT_OF_STOCK", label: OUT_OF_STOCK_STATUS },
  {
    id: "RESOLVED_REFUND_CUSTOMER,RESOLVED_RELEASE_PROVIDER",
    label: RESOLVED_STATUS,
  },
  {
    id: "PENDING_APPROVAL",
    label: PENDING_APPROVAL,
  },
  {
    id: "CONTRACT_REJECTED",
    label: CONTRACT_REJECTED,
  },
  {
    id: "PENDING_PAYMENT_VERIFICATION",
    label: PENDING_PAYMENT_VERIFICATION,
  },
];

export const closed_status = [
  { id: "ALL_CASES", label: "الكل" },
  { id: "COMPLETED", label: COMPLETED_STATUS },
  {
    id: "CLOSED_REFUND_CUSTOMER,CLOSED_RELEASE_PROVIDER",
    label: CLOSED_STATUS,
  },
];

export const categoryOptions = [
  { id: "", label: "الكل" },
  { id: "Electronics", label: "Electronics" },
  { id: "mobiles & accessories", label: "mobiles & accessories" },
  { id: "Home supplies", label: "Home supplies" },
  { id: "AV Eq & accessories", label: "AV Eq & accessories" },
  { id: "Laptops & Tablets", label: "Laptops & Tablets" },
  { id: "Gaming tools", label: "Gaming tools" },
  { id: "PC & accessories", label: "PC & accessories" },
  { id: "Digital goods", label: "Digital goods" },
  { id: "Digital Account", label: "Digital Account" },
  { id: "Gaming Account", label: "Gaming Account" },
  { id: "Social Media", label: "Social Media" },
  { id: "Services", label: "Services" },
  { id: "Food", label: "Food" },
  { id: "Decorations", label: "Decorations" },
  { id: "Personal Items", label: "Personal Items" },
  { id: "Cars", label: "Cars" },
  { id: "Car plates", label: "Car plates" },
  { id: "Cars parts", label: "Cars parts" },
  { id: "Others", label: "Others" },
];

export const operationalStatusOptions = [
  { id: "", label: "الكل" },
  { id: "المشتري دفع", label: "المشتري دفع" },
  { id: "البائع شحن", label: "البائع شحن" },
  { id: "بانتظار المشتري لاستلامها", label: "بانتظار المشتري لاستلامها" },
  { id: "المشتري استلم", label: "المشتري استلم" },
  { id: "بدأت فترة الفحص", label: "بدأت فترة الفحص" },
  { id: "انتهاء فتره الفحص", label: "انتهاء فتره الفحص" },
  {
    id: "بانتظار تأكيد التحويل البنكي",
    label: "بانتظار تأكيد التحويل البنكي",
  },
  { id: "عكس عملية الشحن", label: "عكس عملية الشحن" },
  { id: "التحويل البنكي مرفوض", label: "التحويل البنكي مرفوض" },
  { id: "غير ظاهرة على وفي", label: "غير ظاهرة على وفي" },
  { id: "أغلقت من قبل المشتري", label: "أغلقت من قبل المشتري" },
  { id: "أغلقت من قبل وفي", label: "أغلقت من قبل وفي" },
  { id: "اغلقت من قبل ApI", label: "اغلقت من قبل ApI" },
  { id: "تحت الاجراء", label: "تحت الاجراء" },
];

export const operationalTypeOptions = [
  { id: "", label: "الكل" },
  { id: "تدخل تقني", label: "تدخل تقني" },
  { id: "مخاطرة عبر ميسر", label: "مخاطرة عبر ميسر" },
  { id: "مخاطرة عبر تابي", label: "مخاطرة عبر تابي" },
  { id: "مشكوك تابي", label: "مشكوك تابي" },
  { id: "مشكوك بتبليغ المشتري", label: "مشكوك بتبليغ المشتري" },
  { id: "مخالفة", label: "مخالفة" },
  { id: "احتيال", label: "احتيال" },
  { id: "تجربة", label: "تجربة" },
  { id: "مخاطرة", label: "مخاطرة" },
];

export const escalationOptions = [
  { id: "", label: "الكل" },
  { id: "عن طريق الخطأ", label: "عن طريق الخطأ" },
  { id: "انتهاء فترة الفحص", label: "انتهاء فترة الفحص" },
  { id: "خلل أو خلاف", label: "خلل أو خلاف" },
  { id: "انتهاء المنتج", label: "انتهاء المنتج" },
  { id: "للتجربة", label: "للتجربة" },
  { id: "آلية الدفع ( كاش / تابي)", label: "آلية الدفع ( كاش / تابي)" },
  { id: "تراجع أحد الأطراف", label: "تراجع أحد الأطراف" },
  { id: "مشكلة باضافة الأيبان", label: "مشكلة باضافة الأيبان" },
  { id: "عدم وضوح الخطوة التالية", label: "عدم وضوح الخطوة التالية" },
  { id: "تغيير فترة الشحن أو الفحص", label: "تغيير فترة الشحن أو الفحص" },
  { id: "آلية الشحن وارفاق البوليصة", label: "آلية الشحن وارفاق البوليصة" },
  {
    id: "عدم وضوح الية العمل (مادي / الكتروني)",
    label: "عدم وضوح الية العمل (مادي / الكتروني)",
  },
];

export const operationResultOptions = [
  { id: "", label: "الكل" },
  { id: "تحت المراجعة", label: "تحت المراجعة" },
  { id: "لم يتم اتخاذ اجراء", label: "لم يتم اتخاذ اجراء" },
  { id: "للتحويل للبائع", label: "للتحويل للبائع" },
  { id: "للتحويل من الادمن", label: "للتحويل من الادمن" },
  {
    id: "للتحويل للبائع والارجاع للمشتري",
    label: "للتحويل للبائع والارجاع للمشتري",
  },
  { id: "للتحويل للمشتري", label: "للتحويل للمشتري" },
  { id: "مغلقة لصالح المشتري", label: "مغلقة لصالح المشتري" },
  { id: "مغلقة لصالح البائع", label: "مغلقة لصالح البائع" },
  {
    id: "مغلقة بالتوزيع بين البائع والمشتري",
    label: "مغلقة بالتوزيع بين البائع والمشتري",
  },
  { id: "لم يتم التحويل", label: "لم يتم التحويل" },
  { id: "مكررة", label: "مكررة" },
  {
    id: "للتحويل للبائع بتعويض للمشتري بمعاملة أخرى",
    label: "للتحويل للبائع بتعويض للمشتري بمعاملة أخرى",
  },
  {
    id: "للتحويل للمشتري مع تجميد المتبقي",
    label: "للتحويل للمشتري مع تجميد المتبقي",
  },
  {
    id: "تعويض للمشتري من معاملة اخرى",
    label: "تعويض للمشتري من معاملة اخرى",
  },
  { id: "للتحويل مرة اخري (ايقاف)", label: "للتحويل مرة اخري (ايقاف)" },
  { id: "للتحويل مرة اخري", label: "للتحويل مرة اخري" },
  { id: "تم ايقاف التحويل", label: "تم ايقاف التحويل" },
  { id: "بانتظار اكمال البيانات", label: "بانتظار اكمال البيانات" },
];

export const shippingCompanyOptions = [
  { id: "", label: "الكل" },
  { id: "سبل", label: "سبل" },
  { id: "أرامكس", label: "أرامكس" },
  { id: "ريد بوكس", label: "ريد بوكس" },
  { id: "سمسا", label: "سمسا" },
  { id: "زاجل", label: "زاجل" },
  { id: "فاستلو", label: "فاستلو" },
  { id: "صاب", label: "صاب" },
  { id: "فديكس", label: "فديكس" },
  { id: "أي مكان", label: "أي مكان" },
  { id: "السيف للنقل البري", label: "السيف للنقل البري" },
  { id: "الوطني السريع للنقليات", label: "الوطني السريع للنقليات" },
  { id: "لاما بوكس", label: "لاما بوكس" },
  { id: "ثابت", label: "ثابت" },
  { id: "درب", label: "درب" },
  { id: "يد بيد", label: "يد بيد" },
  { id: "ثابت", label: "ثابت" },
  { id: "ناقل", label: "ناقل" },
  { id: "وصلة", label: "وصلة" },
  { id: "أخرى", label: "أخرى" },
  { id: "J & T", label: "J & T" },
  { id: "DHL", label: "DHL" },
  { id: "UPS", label: "UPS" },
  { id: "17TRACK", label: "17TRACK" },
  { id: "Antex", label: "Antex" },
  { id: "global cainiao", label: "global cainiao" },
  { id: "Receivehere", label: "Receivehere" },
  { id: "Mil", label: "Mil" },
  { id: "GFS", label: "GFS" },
  { id: "OTO", label: "OTO" },
  { id: "AJEX", label: "AJEX" },
  { id: "Smart ship", label: "Smart ship" },
];

export const cashOutOptions = [
  { id: "", label: "الكل" },
  { id: "Moyaser", label: "Moyaser" },
  { id: "Tabby", label: "Tabby" },
  { id: "Inma", label: "Inma" },
  { id: "Rajhi", label: "Rajhi" },
  { id: "Singel Viwe", label: "Singel Viwe" },
  { id: "Moyaser & Singel Viwe", label: "Moyaser & Singel Viwe" },
  { id: "Tabby & Single View", label: "Tabby & Single View" },
  { id: "Tabby & Rajhi", label: "Tabby & Rajhi" },
  { id: "Single view & Rajhi", label: "Single view & Rajhi" },
  { id: "Moyaser & Rajhi", label: "Moyaser & Rajhi" },
];

export const cashOutOutTypeOptions = [
  { id: "", label: "الكل" },
  { id: "طلب سحب", label: "طلب سحب" },
  { id: "سحب الى", label: "سحب الى" },
  { id: "تحويل يدوي", label: "تحويل يدوي" },
];
